export enum StationReceiverType {
  FUNCUBE = 'funcube',
  RTL = 'rtl',
}

export const StationReceiverTypeTitles = new Map<StationReceiverType, string>([
  [StationReceiverType.FUNCUBE, 'FunCube'],
  [StationReceiverType.RTL, 'RTL'],
]);
